// extracted by mini-css-extract-plugin
export default {"mainSection":"titledsection_mainSection__2qr-K","title":"titledsection_title__obdQK","actions":"titledsection_actions__nbqoJ","content":"titledsection_content__5llrE"};